"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class NotificationCenter extends base_1.default {
    getNotifications(data) {
        return this.get('/notification-center', data);
    }
    markAsRead(id) {
        return this.put(`/notification-center/mark-read/${id}`);
    }
    markAllAsRead() {
        return this.put('/notification-center/mark-all-read');
    }
}
exports.default = new NotificationCenter();
